import { Environments } from '@product/cabify-environments';

import { type ApplicationConfig } from './index';

const getHostnameWithoutSubdomain = () => {
  const parts = window.location.hostname?.split('.');

  if (parts?.length > 3) {
    parts.shift();
  }

  return parts.join('.');
};

export const config: ApplicationConfig = {
  appEnv: Environments.TESTING,
  url: {
    apiBase: `https://${getHostnameWithoutSubdomain()}/support/api`,
  },
};
